import * as actionTypes from "../actionTypes";

export default (state, action) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.AUTH_SUCCESS:
      return {
        ...state,
        token: action.payload,
        loading: false,
        isAuthenticated: true,
      };

    case actionTypes.SET_USER_DETAILS:
      return {
        ...state,
        loading: false,

        currentUser: action.payload.user,
        sidebar: action.payload.sidebar,
        permissionKeys: action.payload.permissionKeys || [],

        isAuthenticated: true,
        photo: action.payload?.user?.photo,
      };

    case actionTypes.AUTH_LOGOUT:
      return {
        ...state,

        isAuthenticated: false,
        token: null,

        currentUser: null,
        sidebar: [],
        permissionKeys: [],

        loading: false,
        authChecked: true,
      };

    case actionTypes.AUTH_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        error: action.payload,
        authChecked: true,
      };

    case actionTypes.AUTH_CHECKED:
      return {
        ...state,
        authChecked: true,
      };

    case "FILE_UPLOAD_START":
      return {
        ...state,
        photoLoad: true,
      };

    case "INTERPRETER_USER_PHOTO":
      return {
        ...state,
        photoLoad: false,
        photoURL: action.payload,
      };

    default:
      return state;
  }
};
